import { useAuth0 } from "@auth0/auth0-react";
import { useCallback } from "react";

const useTokenAccess = () => {
  const { getAccessTokenSilently, logout } = useAuth0();

  const getToken = useCallback(async () => {
    try {
      return await getAccessTokenSilently();
    } catch (e) {
      // If there are errors with getting the access token,
      // We can assume that the session has expired.
      // Clear storage and force the user to login again.
      localStorage.clear();
      sessionStorage.clear();
      logout({
        logoutParams: {
          returnTo: process.env.REACT_APP_URL,
          client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
        },
      });
    }

    return "";
  }, [getAccessTokenSilently, logout]);

  return { getToken };
};

export default useTokenAccess;
